export default (axios) => axios.get('/card/binding-details');
